export const GIFTING_FAQ_CMS_CATEGORY_LABEL = 'Delivery';

export const GIFTING_FAQ_SECTION_HEADING = 'QUESTIONS, ANSWERED.';

export const GIFTING_FAQ_CONTACT_TAB_PATH = '/contact/frequently-asked-questions';

export const GIFTING_FAQ_SEE_ALL_LABEL = 'See all FAQs';

export const GIFTING_FAQ_PROMO_MENU_PATH = '/menu';

export const GIFTING_FAQ_PROMO_HEADLINE_LINES = [
  "SOMEONE'S",
  'ABOUT',
  'TO HAVE',
  'A GREAT',
  'NIGHT.',
];

/** Figma 81:552 — one centered headline block (same words as desktop, single flow). */
export const GIFTING_FAQ_PROMO_HEADLINE_MOBILE = GIFTING_FAQ_PROMO_HEADLINE_LINES.join(' ');

export const GIFTING_FAQ_PROMO_TITLE = 'Gift something sweet';

export const GIFTING_FAQ_PROMO_BODY = 'Send a warm treat right to their door, with a note from you.';

export const GIFTING_FAQ_PROMO_CTA_LABEL = 'Send a Gift';
